const day = 'rgb(255,255,255)'
const night = 'rgb(25,25,25)'
export default {
  day,
  night
}
